import React, { useEffect, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import "./CataProductPage.css";
import carddefault from "./../../../assets/carddefault.png";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { MAGNIFY } from "../../comman/components/CommonimagePath";
import PaginationPage from "../../comman/components/PaginationPage";
import { getRequestcall } from "../../comman/util/getRequest";
import { LIST_MASTER_PRODUCTS } from "../../constants/apiurl";
import TablePage from "../../comman/table/TablePage";
import ButtonPage from "../../comman/button/ButtonPage";

function CataProductPage(props) {
  const [selectedItem, setSelectedItem] = useState("");
  const { t } = useTranslation();
  const [selectsubcategory, setSelectsubcategory] = useState([]);
  const [productlist, setProductlist] = useState({
    data: [],
    links: [],
  });
  const { state } = useLocation();
  const navigate = useNavigate();
  const [searchproduct, setSearchproduct] = useState("");
  const [catalogarray, setCatalogarray] = useState([]);
  const [nopagination, setNopagination] = useState();

  useEffect(() => {
    (async () => showProductlist())();
    // eslint-disable-next-line
  }, [props?.language]);

  const showProductlist = async () => {
    props?.fetchHeaderContent(t("pages.products.browse_catalog"), "", "");
    let getsubValue = state?.subcatagory?.map((e) => e.value).join(",");
    setSelectsubcategory(state?.subcatagory);
    await callProductlist(getsubValue, 1, "");
  };

  const callProductlist = async (getsubValue, page, search) => {
    let geturl =
      LIST_MASTER_PRODUCTS +
      `?service_id=${
        state?.catagory
      }&sub_service_id=${getsubValue}&search=${search}&page=${page}&lang=${props?.language?.toLowerCase()}`;
    let getlistmasterproductapiresponse = await getRequestcall(
      geturl,
      props?.access_token
    );
    if (getlistmasterproductapiresponse?.status === 200) {
      let getProducts = await getlistmasterproductapiresponse.json();
      if (getProducts?.data?.data?.length > 0) {
       const data =  getProducts?.data?.data?.map((item)=>{
          return {...item, image_url:item?.img_url ? item?.img_url[0]:""}
        })
        setProductlist({...getProducts?.data, data:data});
        setNopagination(false);
      } else {
        setNopagination(true);
      }
    }
  };

  const handlePageChange = async (pageNumber) => {
    if (selectedItem !== "") {
      callProductlist(selectedItem, pageNumber, searchproduct);
    } else {
      let getsubValue = state?.subcatagory?.map((e) => e.value).join(",");
      callProductlist(getsubValue, pageNumber, searchproduct);
    }
  };

  const selectSubcategory = async (getsubValue, search) => {
    if (getsubValue === "") {
      let getsubValues = state?.subcatagory?.map((e) => e.value).join(",");
      setSelectsubcategory(state?.subcatagory);
      setSelectedItem(getsubValue);
      await callProductlist(getsubValues, 1, search);
    } else {
      callProductlist(getsubValue, 1, search);
      setSelectedItem(getsubValue);
    }
  };

  const checkProduct = (e, id) => {
    let product = [...catalogarray];
    if (e.target.checked === true) {
      let getProduct = productlist?.data?.filter((item) => item.id === id);
      product.push(getProduct[0]);
    } else {
      product = product.filter((item) => item?.id !== id);
    }
    setCatalogarray(product);
  };
  const onClickCheckProduct = (item) => {
    const id = item?.id;
    let product = [...catalogarray];
    const checkIn =
      catalogarray?.filter((item1) => item1?.id === id)?.length === 0
        ? true
        : false;
    if (checkIn === true) {
      let getProduct = productlist?.data?.filter((item) => item.id === id);
      product.push(getProduct[0]);
    } else {
      product = product.filter((item) => item?.id !== id);
    }
    setCatalogarray(product);
  };
  const AddCatalogProducts = () => {
    if (catalogarray?.length === 0) {
      toast.error(t("pages.catalog.select_product"));
    } else {
      const data = catalogarray.map((item) => {
        return { ...item, imageName: [] };
      });
      navigate("/vendor/products/catalog/edit", {
        state: { catalogarray: data },
      });
    }
  };

  const searchOnchange = async (e) => {
    setSearchproduct(e.target.value);
    selectSubcategory("", e.target.value);
  };
  const Data = productlist?.data?.map((item)=>{
    return{...item, is_check:catalogarray?.filter(
      (item1) => item1?.id === item?.id
    )?.length === 0
      ? false
      : true}
  })
  return (
    <div className="col-xl-9 main-content productCatalog">
      <div className="card catalog_card">
        <div className="card-body catalog_body">
          <div className={"search_subcategory mb-3"}>
            <InputGroup className="search_input mb-2">
              <InputGroup.Text id="basic-addon1">
                <img
                  src={MAGNIFY}
                  className="search-icon"
                  alt="search"
                  height="22"
                  width="22"
                ></img>
              </InputGroup.Text>
              <FormControl
                placeholder={t("pages.catalog.search_product")}
                value={searchproduct}
                onChange={searchOnchange}
              />
            </InputGroup>
            <ButtonPage
              Text={state?.subcatagory?.length === 0
                ? t("pages.catalog.backto_cate")
                : t("pages.catalog.back_subcate")}
              onClick={() =>
                state?.subcatagory?.length === 0
                  ? navigate("..")
                  : navigate(`/vendor/products/catalog/${state?.catagory}`)
              }
              className={"button-black"}
            />
          </div>
          <div className="mb-3">
            <h5>{t("pages.catalog.select_product")}</h5>
          </div>
          <div className="">
            <div className="swipper_content">
              {
                <div className={"sidebar-cateloge-slider "}>
                  {selectedItem === "" ? (
                    <div
                      className={"swipper-text active"}
                      onClick={() => selectSubcategory("", searchproduct)}
                    >
                      {t("pages.catalog.all")}
                    </div>
                  ) : (
                    <div
                      className={"swipper-text "}
                      onClick={() => selectSubcategory("", searchproduct)}
                    >
                      {t("pages.catalog.all")}
                    </div>
                  )}
                  {selectsubcategory.map((item, index) => (
                    <div
                      onClick={() =>
                        selectSubcategory(item?.value, searchproduct)
                      }
                      key={index.toString()}
                      className={
                        selectedItem === item?.value
                          ? "swipper-text active"
                          : "swipper-text"
                      }
                    >
                      {props?.language === "En" ? item?.label : item?.label_tr}
                    </div>
                  ))}
                </div>
              }
            </div>
          </div>
          <div class="table-responsive">
            <TablePage
              headData={[t("pages.catalog.product_image"), t("pages.catalog.product_name"), t("pages.catalog.description")]}
              data={Data}
              search={searchproduct}
              onChange={checkProduct}
              onClick={onClickCheckProduct}
              title={true}
              description={true}
              default_img={carddefault}
            />
          </div>
          <div className="d-flex justify-flex-end submit_div">
            <ButtonPage
              Text={
                <React.Fragment>
                  {t("pages.catalog.proceed")}{" "}
                  {catalogarray?.length === 0 ? "" : `(${catalogarray.length})`}
                </React.Fragment>
              }
              onClick={() => AddCatalogProducts()}
              className={
                catalogarray?.length === 0
                  ? "button-submit d-none"
                  : "button-submit d-block"
              }
            />
          </div>
          {productlist?.total > 10 && (
            <div className="text-end">
              {productlist?.data?.length !== 0 && (
                <PaginationPage
                  changeCurrentpage={handlePageChange}
                  nopagination={nopagination}
                  links={productlist?.links}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(
  CataProductPage
);
